<section class="work-exception-dialog">
  <div class="work-exception-dialog__header">
    <span class="work-exception-dialog__header-icon"><mat-icon>event_available</mat-icon></span>
    <div class="work-exception-dialog__heading">
      <h2>{{ dialogTitle }}</h2>
      <p>{{ dialogDescription }}</p>
    </div>
    <button mat-icon-button type="button" class="work-exception-dialog__close" (click)="close()"
            [disabled]="isSaving || isDeleting" [attr.aria-label]="'common.close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="work-exception-dialog__content">
    @if (isLoading) {
    <div class="work-exception-dialog__loading"><mat-icon>hourglass_top</mat-icon>{{ 'workExceptionsCatalog.loading' | translate }}</div>
    } @else {
    <div class="work-exception-dialog__summary-grid">
      <div class="work-exception-dialog__summary-card">
        <span>{{ 'workExceptionsCatalog.fields.employee' | translate }}</span>
        <strong>{{ employeeName }}</strong>
        @if (employeeNumber) { <small>{{ employeeNumber }}</small> }
      </div>
      <div class="work-exception-dialog__summary-card">
        <span>{{ 'workExceptionsCatalog.fields.date' | translate }}</span>
        <strong>{{ data.date }}</strong>
        <small>{{ exceptionWeekday }}</small>
      </div>
      <div class="work-exception-dialog__summary-card">
        <span>{{ 'workExceptionsCatalog.dialog.currentSchedule' | translate }}</span>
        <strong>{{ data.currentScheduleLabel }}</strong>
      </div>
    </div>

    <div class="work-exception-dialog__section-heading">
      <h3>{{ 'workExceptionsCatalog.dialog.typeTitle' | translate }}</h3>
    </div>
    <div class="work-exception-dialog__type-grid" role="radiogroup">
      <button type="button" class="work-exception-dialog__type-card" [class.is-selected]="isWorkDay"
              [disabled]="isSaving || isDeleting" role="radio" [attr.aria-checked]="isWorkDay"
              (click)="selectDayType('work')">
        <span class="work-exception-dialog__radio"></span>
        <span class="work-exception-dialog__type-icon"><mat-icon>schedule</mat-icon></span>
        <span><strong>{{ 'workExceptionsCatalog.dialog.workTypeTitle' | translate }}</strong>
          <small>{{ 'workExceptionsCatalog.dialog.workTypeDescription' | translate }}</small></span>
      </button>
      <button type="button" class="work-exception-dialog__type-card" [class.is-selected]="isRestDay"
              [disabled]="isSaving || isDeleting" role="radio" [attr.aria-checked]="isRestDay"
              (click)="selectDayType('rest')">
        <span class="work-exception-dialog__radio"></span>
        <span class="work-exception-dialog__type-icon"><mat-icon>event_available</mat-icon></span>
        <span><strong>{{ 'workExceptionsCatalog.dialog.restTypeTitle' | translate }}</strong>
          <small>{{ 'workExceptionsCatalog.dialog.restTypeDescription' | translate }}</small></span>
      </button>
    </div>

    @if (isWorkDay) {
    <div class="work-exception-dialog__field-block">
      <h3>{{ 'workExceptionsCatalog.dialog.scheduleTitle' | translate }}</h3>
      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="work-exception-dialog__schedule-field">
        <mat-icon matPrefix>schedule</mat-icon>
        <mat-select [(ngModel)]="dailyScheduleId" [disabled]="isSaving || isDeleting"
                    [placeholder]="'workExceptionsCatalog.fields.dailySchedule' | translate">
          @for (schedule of schedules; track schedule.dailyScheduleId) {
          <mat-option [value]="schedule.dailyScheduleId">{{ schedule.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <small class="work-exception-dialog__schedule-hint">{{ 'workExceptionsCatalog.dialog.scheduleNotice' | translate }}</small>
    </div>
    }

    <div class="work-exception-dialog__field-block">
      <div class="work-exception-dialog__field-title">
        <h3>{{ 'workExceptionsCatalog.dialog.reasonTitle' | translate }}</h3>
        <span>{{ 'workExceptionsCatalog.dialog.optional' | translate }}</span>
      </div>
      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="work-exception-dialog__reason-field">
        <textarea matInput rows="3" maxlength="200" [(ngModel)]="reason" [disabled]="isSaving || isDeleting"
                  [placeholder]="'workExceptionsCatalog.dialog.reasonPlaceholder' | translate"></textarea>
        <mat-hint align="end">{{ reasonLength }}/200</mat-hint>
      </mat-form-field>
    </div>

    @if (isEditMode) {
    <div class="work-exception-dialog__toggle-card">
      <div><strong>{{ 'workExceptionsCatalog.fields.status' | translate }}</strong>
        <p>{{ 'workExceptionsCatalog.fields.statusHint' | translate }}</p></div>
      <mat-slide-toggle [(ngModel)]="isActive" [disabled]="isSaving || isDeleting"></mat-slide-toggle>
    </div>
    }
    }
  </mat-dialog-content>

  <mat-dialog-actions class="work-exception-dialog__actions">
    @if (!isLoading && isEditMode) {
    <button mat-stroked-button type="button" class="btn-tone-danger work-exception-dialog__delete"
            (click)="deleteCurrent()" [disabled]="isSaving || isDeleting">
      <mat-icon>delete_outline</mat-icon>{{ 'common.delete' | translate }}
    </button>
    }
    <button mat-stroked-button type="button" class="btn-tone-neutral" (click)="close()"
            [disabled]="isSaving || isDeleting">{{ 'common.cancel' | translate }}</button>
    <button mat-flat-button type="button" class="btn-tone-primary" (click)="save()"
            [disabled]="isLoading || isSaving || isDeleting || !canSave">
      <mat-icon>save</mat-icon>{{ isEditMode ? ('common.saveChanges' | translate) : ('workExceptionsCatalog.dialog.createAction' | translate) }}
    </button>
  </mat-dialog-actions>
</section>
